<script lang="ts">
    import {page} from '$app/stores';
    import {
        IconSolid,
    } from "flowbite-svelte-icons";
    import {afterNavigate} from "$app/navigation"
    import {Sidebar as FlowbiteSidebar, SidebarGroup, SidebarItem, SidebarWrapper, Tooltip} from "flowbite-svelte";
    import {currentRoute} from "$lib/stores/route";
    import sideMenuItems from "$lib/utils/sideMenuItems";
    import {user} from "$lib/stores/auth";

    export let displayMenuText = true



    let urlPath: string;
    $: urlPath = $page.url.pathname;


    const menus = sideMenuItems.filter(x => $user?.scope?.includes(x.href))
    afterNavigate(() => {
        currentRoute.set(menus.find(x => x.href === urlPath || x.href.length > 2 && urlPath.startsWith(x.alias ?? x.href)));
    })


</script>
<FlowbiteSidebar class="bg-transparent" asideClass="">
    <SidebarWrapper class="bg-transparent">
        <SidebarGroup>
            {#each menus as menu}
                <SidebarItem spanClass={displayMenuText ? 'ml-3': ''} href={menu.href} label={displayMenuText ? menu.label : ''} active={menu.href === urlPath}>
                    <svelte:fragment slot="icon">
                        <IconSolid icon={menu.icon}
                              class="w-5 h-5 {menu.href === urlPath ? 'text-primary-600': 'text-gray-500'} transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"/>
                        {#if !displayMenuText}<Tooltip class="z-20" placement="right">{menu.label}</Tooltip>{/if}
                    </svelte:fragment>
                </SidebarItem>
            {/each}
        </SidebarGroup>
    </SidebarWrapper>
</FlowbiteSidebar>

